import $ from "jquery";

// Helper to convert base64url to Uint8Array
function base64urlToUint8Array(base64url) {
    // Replace base64url chars with base64 chars
    let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '='
    while (base64.length % 4) base64 += '=';
    const str = atob(base64);
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; ++i) {
        bytes[i] = str.charCodeAt(i);
    }
    return bytes;
}

function getIdentityServerBasePath() {
    const path = window.location.pathname;
    const match = path.match(/^(.*?)(?:\/identityserver)?\/account\//i);
    if (match) {
        return match[1];
    }
    return '';
}

function uint8ArrayToBase64(uint8Array) {
    return btoa(String.fromCharCode.apply(null, uint8Array));
}

export function initPasskeyLogin() {
    const passkeyLoginBtn = document.getElementById('btn-passkey-login');
    if (!passkeyLoginBtn) return;

    const basePath = getIdentityServerBasePath();

    $('#btn-passkey-login').on('click', async function (e) {
        e.preventDefault();
        $('#passkey-error').addClass('d-none').find("li").text('');

        try {
            // 1. Get challenge from server
            const challengeResponse = await fetch(basePath + '/passkey/login/begin', {
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
                },
                method: 'POST'
            });
            if (!challengeResponse.ok) throw new Error('Failed to get passkey challenge. Please try again later.');
            const publicKey = await challengeResponse.json();

            // Convert challenge and allowCredentials to Uint8Array
            publicKey.challenge = base64urlToUint8Array(publicKey.Base64Challenge);
            if (publicKey.Base64KeyIds) {
                publicKey.allowCredentials = publicKey.Base64KeyIds.map(cred => ({
                    ...cred,
                    id: Uint8Array.from(atob(cred), c => c.charCodeAt(0))
                }));
            }
            publicKey.rp = {};
            publicKey.rp.id = publicKey.RelyingPartyId;
            publicKey.rp.name = "YardiOne";

            // 2. Call WebAuthn API
            const assertion = await navigator.credentials.get({ publicKey });

            // 3. Prepare data for server
            const authData = {
                id: assertion.id,
                rawId: btoa(String.fromCharCode(...new Uint8Array(assertion.rawId))),
                type: assertion.type,
                response: {
                    authenticatorData: btoa(String.fromCharCode(...new Uint8Array(assertion.response.authenticatorData))),
                    clientDataJSON: btoa(String.fromCharCode(...new Uint8Array(assertion.response.clientDataJSON))),
                    signature: btoa(String.fromCharCode(...new Uint8Array(assertion.response.signature))),
                    userHandle: assertion.response.userHandle
                        ? uint8ArrayToBase64(new Uint8Array(assertion.response.userHandle))
                        : null
                }
            };

            // 4. Send assertion to server
            const csrfToken = document.querySelector('input[name="__RequestVerificationToken"]')?.value;
            const headers = { 'Content-Type': 'application/json' };
            if (csrfToken) headers['RequestVerificationToken'] = csrfToken;

            const verifyResponse = await fetch(basePath + '/passkey/login/complete', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(authData)
            });

            if (!verifyResponse.ok) throw new Error('Passkey verification failed. Please try again.');

            const returnUrl = document.getElementById('hidd_txtReturnURL')?.value || '/';
            window.location.href = returnUrl;
        } catch (err) {
            $('#passkey-error').removeClass('d-none').find("li").text(err.message || 'Passkey login failed.');
        }
    });
}
